const AutoFocus = {
  inserted(el) {
    el.focus();
  }
};

export default AutoFocus


